import { handleActions } from "redux-actions";
import { MERCHANT } from "constants/action-types";
import { IQuery, IMutate, RequestStatus } from "constants/crud";
import {
    GetMerchantDefaultAllocationDimensionsPreferenceRequestAction,
    GetMerchantDefaultAllocationDimensionsPreferenceCompleteAction,
    UpdateMerchantDefaultAllocationDimensionsPreferenceRequestAction,
    UpdateMerchantDefaultAllocationDimensionsPreferenceCompleteAction,
} from "actions/merchant";
import { IMerchantDefaultAllocationDimensionsPreference } from "constants/merchant";

export interface IState
    extends IQuery<IMerchantDefaultAllocationDimensionsPreference>,
        IMutate<IMerchantDefaultAllocationDimensionsPreference> {}

const initialState: IState = {
    queryError: undefined,
    queryStatus: RequestStatus.Active,
    mutateStatus: RequestStatus.Idle,
    mutateError: undefined,
    result: undefined,
};

export const merchantDefaultAllocationDimensionsPreference = handleActions<IState, any>(
    {
        [MERCHANT.DEFAULT_ALLOCATION_DIMENSIONS_PREFERENCE.GET.REQUEST]: (
            state: IState,
            _action: GetMerchantDefaultAllocationDimensionsPreferenceRequestAction
        ): IState => {
            return {
                ...state,
                ...initialState,
            };
        },
        [MERCHANT.DEFAULT_ALLOCATION_DIMENSIONS_PREFERENCE.GET.COMPLETE]: (
            state: IState,
            action: GetMerchantDefaultAllocationDimensionsPreferenceCompleteAction
        ): IState => {
            return {
                ...state,
                queryStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                queryError: action.payload instanceof Error ? action.payload : undefined,
                result: action.payload instanceof Error ? undefined : action.payload,
            };
        },
        [MERCHANT.DEFAULT_ALLOCATION_DIMENSIONS_PREFERENCE.UPDATE.REQUEST]: (
            state: IState,
            _action: UpdateMerchantDefaultAllocationDimensionsPreferenceRequestAction
        ): IState => {
            return {
                ...state,
                mutateStatus: RequestStatus.Active,
                mutateError: undefined,
            };
        },
        [MERCHANT.DEFAULT_ALLOCATION_DIMENSIONS_PREFERENCE.UPDATE.COMPLETE]: (
            state: IState,
            action: UpdateMerchantDefaultAllocationDimensionsPreferenceCompleteAction
        ): IState => {
            return {
                ...state,
                mutateError: action.payload instanceof Error ? action.payload : undefined,
                mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                result: action.payload instanceof Error ? undefined : action.payload,
            };
        },
    } as any,
    initialState
);
